import { HttpClient } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { InyovaConfigService } from '@inyova/inyova-shared';
import { WITHDRAWAL_PROMO_CODE } from '@inyova/mocks';
import { BankAccountDetail, IBANItem, WithdrawalReasons, WithdrawRequest } from '@inyova/models';

import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Injectable()
export class WithdrawalService implements OnDestroy {
  protected readonly onDestroy$ = new Subject<void>();
  private url: string;
  private urlV3: string;
  private accountID: string;
  constructor(
    private http: HttpClient,
    private sharedService: InyovaConfigService
  ) {
    this.sharedService
      .getApiData()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((apiData) => {
        this.url = apiData.url;
        this.urlV3 = apiData.urlV3;
        this.accountID = apiData.accountID;
      });
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  checkWithdrawalInProgress(): Observable<{ data: WithdrawRequest[] }> {
    return this.http.get<{ data: WithdrawRequest[] }>(
      `${this.urlV3}/new_funds_withdrawal_requests?filter[status]=in_progress&filter[account_id]=${this.accountID}`
    );
  }

  activateWithdrawalPromotion(): Observable<any> {
    const payload = {
      data: { type: 'promotion_redemptions', attributes: { code: WITHDRAWAL_PROMO_CODE } }
    };
    return this.http.post<any>(`${this.urlV3}/promotion_redemptions?include=promotions`, payload);
  }

  getIBANList(): Observable<{ data: IBANItem[]; meta: [] }> {
    return this.http.get<{ data: IBANItem[]; meta: [] }>(`${this.urlV3}/beneficiaries?filter[account_id]=${this.accountID}`);
  }

  getWithdrawalReasonOptions(): Observable<{ id: number; name: string; survey_questions: WithdrawalReasons[] }> {
    return this.http.get<{ id: number; name: string; survey_questions: WithdrawalReasons[] }>(
      `${this.url}/accounts/${this.accountID}/survey/withdrawals_feedback`
    );
  }

  checkCustomerIBAN(body: { iban: string }): Observable<BankAccountDetail> {
    return this.http.post<BankAccountDetail>(`${this.url}/account_opening/iban_verification`, body);
  }

  sendWithdrawalRequest(data: WithdrawRequest): Observable<WithdrawRequest> {
    return this.http.post<WithdrawRequest>(`${this.urlV3}/new_funds_withdrawal_requests`, { data });
  }
}
